<span *ngIf="isDispLoadingImage">
  <div class="loading-wrapper">
    <!-- <img src="../assets/images/loading_150px.gif" [class]="loadImgClass" alt="NOW LOADING..."/> -->
    <div class="loader"></div>
    <img class="image" src="../../../../assets/images/icon_cafee.png">
    <!-- 「いただきます」での通信中表示 文字色の違いを出す調整 -->
    <div *ngIf="loadType === 'checkItadakimasu'" class="itadakimasu-loading-data mt-2">
      {{ message }}
    </div>
    <!-- 「いただきます以外」での通信表示 文字色の違いを出す調整 -->
    <div *ngIf="loadType !== 'checkItadakimasu'" class="loading-data mt-2">
      {{ message }}
    </div>
  </div>
</span>